import { render, staticRenderFns } from "./RightsliDialog.vue?vue&type=template&id=425e6e35&scoped=true&"
import script from "./RightsliDialog.vue?vue&type=script&lang=js&"
export * from "./RightsliDialog.vue?vue&type=script&lang=js&"
import style0 from "./RightsliDialog.vue?vue&type=style&index=0&id=425e6e35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e6e35",
  null
  
)

export default component.exports